import { I18N_NAMESPACE } from "@l2r-front/l2r-shared-campaign"
import { yup } from "@l2r-front/l2r-utils"


export const validationSchema = (t, existingCampaignNames = []) => yup.object().shape({
    campaign_type: yup.string().required(t(I18N_NAMESPACE, "forms.campaignForm.campaignTypeRequired")),
    company_name: yup.string().nullable(),
    color: yup.string().required(t(I18N_NAMESPACE, "forms.campaignForm.colorRequired")),
    date_start: yup.date()
        .typeError(t(I18N_NAMESPACE, "forms.campaignForm.invalidDate"))
        .required(t(I18N_NAMESPACE, "forms.campaignForm.dateStartRequired")),
    date_end: yup.date().nullable()
        .typeError(t(I18N_NAMESPACE, "forms.campaignForm.invalidDate"))
        .test(
            "date_end-after-date_start",
            t(I18N_NAMESPACE, "forms.campaignForm.dateEndBeforeDateStart"),
            function (value) {
                const { date_start } = this.parent
                if (!value || !date_start) {
                    return true
                }
                return value >= date_start
            },
        ),
    name: yup.string()
        .required(t(I18N_NAMESPACE, "forms.campaignForm.nameRequired"))
        .notOneOf(existingCampaignNames, t(I18N_NAMESPACE, "forms.campaignForm.nameAlreadyExists")),
    tags: yup.array(yup.string()),
    comment: yup.string().nullable(),
})